import _get from 'lodash/get';

import { SET_TXN_OVERVIEW, SET_TRANSACTION_DETAILS, RESET, SET_VEHICLE_DETAIL } from './constants';

const initialState = {
  loading: false,
  loaded: false,
  overview: {},
  transactionData: {},
  vehicleData: {},
};

const modifyList = (list: any, vNum: string) => {
  if (!(list && list.length)) {
    return [];
  }
  return list.map((vehicle: any) => {
    return { ...vehicle, vehicleNumber: vNum };
  });
};

const fasTagDetail = (state: any = initialState, action: any) => {
  switch (action.type) {
    case SET_TXN_OVERVIEW:
      return {
        ...state,
        overview: action.data,
      };
    case SET_VEHICLE_DETAIL:
      const data = _get(action, 'data.list', []);
      const { vNum } = action.data;
      let vehicleData = data[0];
      const vehicle = data.find((vehicle: any) => vehicle.vehicleNumber.toLowerCase() === vNum.toLowerCase());
      if (vehicle) {
        vehicleData = vehicle;
      }
      return {
        ...state,
        vehicleData,
      };
    case SET_TRANSACTION_DETAILS: {
      let list: Array<object> = [];
      const vehicleNumber = action.data.vehicleNum;
      const transactionList = modifyList(action.data.list, vehicleNumber);
      if (!action.data.reset) {
        if (state.transactionData.list && state.transactionData.list.length) {
          list = [...list, ...state.transactionData.list];
        }
      }
      if (transactionList && transactionList.length) {
        list = [...list, ...transactionList];
      }
      return {
        ...state,
        transactionData: {
          ...action.data,
          list,
        },
        loaded: true,
      };
    }
    case RESET:
      return initialState;
    default:
      return state;
  }
};

export default fasTagDetail;
